import React from 'react';
import { useSelector } from 'react-redux';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';

// import components
import ButtonBackArrow from 'js/components/button/Button.back-arrow';

import FindConfirmButton from 'js/components/find/Find.confirm-button';
import FindPlayTypeOptions from 'js/components/find/Find.play-type-options';
import FindPlayersOptions from 'js/components/find/Find.player-options';
import FindMaterialsOptions from 'js/components/find/Find.materials-options';
import FindMinutesOptions from 'js/components/find/Find.minutes-options';

import IconShapes from 'js/components/icon/Icon.shapes';

const FindStep2 = ({ setCurrentStep }) => {
  const text = {
    activity_1: useSelector((state) =>
      getTranslationById(state, 'find_step_1_time_to_transition', 'Time to Transition')
    ),
    activity_2: useSelector((state) => getTranslationById(state, 'find_step_1_lets_get_moving', "Let's Get Moving")),
    activity_3: useSelector((state) =>
      getTranslationById(state, 'find_step_1_calm_and_collected', 'Calm and Collected')
    ),
  };

  const selectedActivity = useSelector((state) => state?.search?.filters?.activity || 'activity_1');
  return (
    <div className="find__step-2">
      <div className="h1-container">
        <ButtonBackArrow action={setCurrentStep} />

        <IconShapes className="icon-shapes" />
        <h1>{`${text[selectedActivity]}`}</h1>
      </div>

      <FindPlayTypeOptions />
      <FindPlayersOptions />
      <FindMinutesOptions />
      <FindMaterialsOptions />
      <FindConfirmButton />
    </div>
  );
};

export default FindStep2;
